import { Banner } from '~core/models/core.models';

export class ResetState {
  static readonly type = '[ProgramBanner] Reset State';
}

export class LoadBanners {
  static readonly type = '[ProgramBanner] Load Banners';
  constructor(
    public data?: {
      programId?: string;
      banners?: Banner[];
    }
  ) {}
}

export class AddBanner {
  static readonly type = '[ProgramBanner] Add Banner';
  constructor(public data: File) {}
}

export class RemoveBanner {
  static readonly type = '[ProgramBanner] Remove Banner';
}

export class SelectBanner {
  static readonly type = '[ProgramBanner] Select Banner';
  constructor(public data: string) {}
}

export class SaveBanner {
  static readonly type = '[ProgramBanner] Save Banner';
}
